<script setup lang="ts">
import { UiIcon, UiText, UiVerticalDivider } from '@shopexperts/shared';
import { computed } from 'vue';

const props = defineProps<{
    stats?: {
        total_published: number;
        average_rating: number;
        average_quality: number;
        average_communication: number;
        average_timelines: number;
        average_value_for_money: number;
    };
}>();

const metrics = computed(() => [
    { label: 'Setup & Ease of Use', value: props.stats?.average_quality },
    { label: 'Features & Functionality', value: props.stats?.average_communication },
    { label: 'Support Quality', value: props.stats?.average_timelines },
    { label: 'Value for Money', value: props.stats?.average_value_for_money },
    {
        label: 'Overall Rating',
        value: props.stats?.average_rating,
        count: props.stats?.total_published
    },
]);
</script>

<template>
    <div class="grid md:flex grid-cols-2 md:gap-6 mb-6 gap-y-4">
        <template v-for="(metric, index) in metrics" :key="index">
            <div class="flex flex-col gap-2">
                <UiText as="label" variant="h6" class="text-gray-600" :text="metric.label" />
                <div class="flex items-center gap-1">
                    <UiIcon name="dynamic-star" class="w-5 h-5 text-se-green" />
                    <UiText as="span" variant="p-small" class="text-2xl font-semibold text-gray-900"
                        :text="metric.value?.toFixed(2) || '0.00'" />
                    <UiText as="span" variant="p-small" class="text-gray-500" :text="`(${metric.count} reviews)`"
                        v-if="metric.count !== undefined" />
                </div>
            </div>
            <UiVerticalDivider class="hidden md:block" height="h-10" />
        </template>
    </div>
</template>
